import React from 'react';
import { tokens as t, fonts as font } from '../../tokens';
import { Avatar } from '../Avatar';

export function Timeline({ children }) {
  const items = React.Children.toArray(children);
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {items.map((child, i) =>
        React.cloneElement(child, { _isLast: i === items.length - 1 })
      )}
    </div>
  );
}

export function ActivityItem({ icon = "○", color = t.emerald, title, subtitle, timestamp, actor, children, _isLast }) {
  return (
    <div style={{ display: "flex", gap: 14, fontFamily: font.body }}>
      {/* Left column: circle + line */}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", flexShrink: 0 }}>
        <div style={{
          width: 28, height: 28, borderRadius: "50%",
          background: `${color}18`, color,
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 12, flexShrink: 0,
        }}>{icon}</div>
        {!_isLast && (
          <div style={{ width: 2, flex: 1, background: t.border, minHeight: 20 }} />
        )}
      </div>
      {/* Right column: content */}
      <div style={{ flex: 1, paddingBottom: _isLast ? 0 : 20, minWidth: 0 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap", marginBottom: 2 }}>
          {actor && <Avatar name={actor} size={20} />}
          <span style={{ fontSize: 13, fontWeight: 600, color: t.textPrimary }}>{title}</span>
          <span style={{ fontSize: 11, color: t.textMuted, fontFamily: font.mono, marginLeft: "auto", flexShrink: 0 }}>{timestamp}</span>
        </div>
        {subtitle && (
          <div style={{ fontSize: 12.5, color: t.textSecondary, marginTop: 3 }}>{subtitle}</div>
        )}
        {children && (
          <div style={{
            marginTop: 8, padding: "10px 14px",
            background: t.surfaceWarm, border: `1px solid ${t.border}`,
            borderRadius: 8, fontSize: 13, color: t.textSecondary,
          }}>{children}</div>
        )}
      </div>
    </div>
  );
}
